import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function About() {
  const { t } = useTranslation();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      
      {/* About Content */}
      <section className="flex-1 flex">
        <div className="w-full max-w-5xl mx-auto px-8 py-16 flex flex-col md:flex-row">
          <div className="w-full md:w-1/2 md:pr-8 mb-8 md:mb-0">
            <div className="mb-8">
              <img 
                src="/assets/images/Hallo!.svg" 
                alt="Hallo!" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-600 mb-6">
              Ik ben Amber en ik knip, droom, denk, puzzel en plak wenskaartjes voor allerlei momenten in je leven. Voor zonnige en warme gelegenheden, maar ook voor moeilijkere momenten van verliezen, zoeken en terugvinden. Om aan anderen te laten weten dat je er voor hen bent én ook om jezelf aan die boodschap te herinneren.
            </p>
            <p className="text-gray-600 mb-6">
              Al bladerend door tijdschriften knip ik woorden uit waar mijn oog op valt, soms met een thema in gedachten, soms niet. En dan begint het meest plezierige: koelkastpoëzie-gewijs woordjes samenpuzzelen. Zo ontstaat midden in de woordenchaos op mijn bureau een speelse, sprekende en soms ontroerende boodschap. Het is telkens weer een verrassing wat er tevoorschijn komt na dat knip- en plakplezier.
            </p>
            <p className="text-gray-600 mb-6">
              Wat begon met een nieuwjaarskaartje en een reeks themakaartjes voor een goed doel, groeide voorzichtig uit tot een hobby die ik met een breder publiek wil delen. Dus tadaa: Atelier Ambree! Je kan al mijn kaartjes terugvinden in de webshop en binnenkort hopelijk ook een selectie ervan in lokale verkooppunten in Brussel en Leuven.
            </p>
            <p className="text-gray-600">
              Zoek je een kaartje met een specifieke boodschap of voor een speciaal iemand? Andere vragen? Stuur me een bericht via{' '}
              <a href="mailto:hallo@atelierambree.be" className="text-ambre-600 hover:text-ambre-700 underline">
                hallo@atelierambree.be
              </a>{' '}
              of Instagram en we bekijken samen hoe ik je verder kan helpen.
            </p>
          </div>
          <div className="w-full md:w-1/2 md:pl-8 flex-1">
            <img 
              src="/assets/images/about-page.jpg" 
              alt="Amber van Atelier Ambree" 
              className="w-full h-full object-cover rounded-xl shadow-lg" 
            />
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default About; 